import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { FromIRBDocumentCacheContainerModel } from '../../../../../models/aggregates/e-invoice/bl_fi_my_einvoice_from_irb_document_cache_container.model';

@Injectable({
  providedIn: 'root'
})
export class FromIRBDocumentCacheService extends BaseApiTemplateService<FromIRBDocumentCacheContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/from-irb-document-caches/backoffice-ep'

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/from-irb-document-caches/backoffice-ep'
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'e-invoice/from-irb-document-caches/backoffice-ep'
    this.httpClient = http;
  }
}
